// Password input with a show/hide (eye) toggle.
// Drop-in: pass the original input's classes via inputClassName; all other
// props (value, onChange, placeholder, ref via inputRef, etc.) pass through.
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "@/i18n";

export default function PasswordInput({ className = "", inputClassName = "", inputRef, ...props }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  return (
    <div className={`relative w-full ${className}`}>
      <input
        {...props}
        ref={inputRef}
        type={show ? "text" : "password"}
        className={`${inputClassName} pr-11 w-full`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? t('common.hidePassword') : t('common.showPassword')}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
